"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isBefore = require("date-fns/is_before");
var isAfter = require("date-fns/is_after");
var date_1 = require("../date");
var dateErrorMessages = {
    badInput: 'Das Datum ist kein gültiges Datum',
    rangeOverflow: 'Das Datum liegt nach dem erlaubten Bereich',
    rangeUnderflow: 'Das Datum liegt vor dem erlaubten Bereich',
    valueMissing: 'Das Datum ist nicht vollständig'
};
function getDateErrors(date, config) {
    var errors = {
        valid: true
    };
    var parsedDate = date_1.asDate(date);
    if (!date.day || !date.month || !date.year) {
        errors.valueMissing = dateErrorMessages.valueMissing;
        errors.valid = false;
    }
    else if (parsedDate === null ||
        !(parseInt(date.day, 10) > 0) ||
        !(parseInt(date.month, 10) > 0) ||
        !(parseInt(date.year, 10) > 0)) {
        errors.badInput = dateErrorMessages.badInput;
        errors.valid = false;
    }
    else if (config && config.maxDate && isAfter(parsedDate, config.maxDate)) {
        errors.rangeOverflow = dateErrorMessages.rangeOverflow;
        errors.valid = false;
    }
    else if (config && config.minDate && isBefore(parsedDate, config.minDate)) {
        errors.rangeUnderflow = dateErrorMessages.rangeUnderflow;
        errors.valid = false;
    }
    return errors;
}
exports.getDateErrors = getDateErrors;
//# sourceMappingURL=date.js.map
